'use strict';

var RomSummaryChartsDataService = function RomSummaryChartsDataService(dataRetrieverService, dataRetrieverConstantsService, RomSummaryOpportunityTrendsChart, RomSummaryLineGraphChart, RomSummaryOpportunityTrendsViewport, RomSummaryLineGraphChartViewport) {
  var yLabels = {
    OPPORTUNITY_TREND: 'Revenue',
    MIN_ACT_MAX_REVENUE: 'Revenue',
    DMND_PAX: 'Passengers',
    AVG_FARE: 'Fare',
    DMND_WEIGHT: 'Percentage'
  };
  function getData(screen, mode, type) {
    return dataRetrieverService.getDataRetriever(screen, mode).localSortApplied().retrieveComponentData(type);
  }
  function getFilters(screen, mode) {
    return dataRetrieverService.getDataRetriever(screen, mode).brushFilters();
  }
  function getFilter(filterType) {
    var filters = getFilters(dataRetrieverConstantsService.ROM_SUMMARY_SCREEN, dataRetrieverConstantsService.ROM_SUMMARY_MODE);
    return filters[filterType];
  }
  function getNewChart(chartContainer, formatter, config, chartType) {
    if (chartType === 'OPPORTUNITY_TREND') {
      return new RomSummaryOpportunityTrendsChart(chartContainer, formatter, config);
    } else {
      config.yAxisLabel = yLabels[chartType];
      return new RomSummaryLineGraphChart(chartContainer, formatter, config);
    }
  }
  function getNewViewport(viewportContainer, chartType) {
    if (chartType === 'OPPORTUNITY_TREND') {
      return new RomSummaryOpportunityTrendsViewport(viewportContainer);
    } else {
      return new RomSummaryLineGraphChartViewport(viewportContainer);
    }
  }
  return {
    getData: getData,
    getFilters: getFilters,
    getFilter: getFilter,
    getNewChart: getNewChart,
    getNewViewport: getNewViewport
  };
};
RomSummaryChartsDataService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService', 'RomSummaryOpportunityTrendsChart', 'RomSummaryLineGraphChart', 'RomSummaryOpportunityTrendsViewport', 'RomSummaryLineGraphChartViewport'];
module.exports = RomSummaryChartsDataService;